import React from "react";
import { Box, Text, HStack, Badge } from "@chakra-ui/react";
import { motion, AnimatePresence } from "framer-motion";

const CenterClock = () => {
  const [now, setNow] = React.useState(new Date());
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  React.useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const { time, date, weekday, greeting } = React.useMemo(() => {
    const h = now.getHours();
    const greeting =
      h < 5
        ? "Good night"
        : h < 12
        ? "Good morning"
        : h < 18
        ? "Good afternoon"
        : "Good evening";

    const time = now.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, // switch to true if you want 12h
    });

    const weekday = now.toLocaleDateString([], { weekday: "long" });
    const date = now.toLocaleDateString([], {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    return { time, date, weekday, greeting };
  }, [now]);

  return (
    <>
      <Box
        as={motion.div}
        initial={{ opacity: 0, y: 10, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ type: "tween", duration: 0.18, ease: "easeOut" }}
        // position="absolute"
        // top="50%"
        // left="50%"
        // minW="380px"
        // transform="translate(-50%, -50%)"
        px={8}
        py={6}
        rounded="2xl"
        bg="rgba(255,255,255,0.18)"
        border="1px solid rgba(255,255,255,.35)"
        backdropFilter="blur(12px)"
        boxShadow="0 30px 80px rgba(0,0,0,.22)"
        textAlign="center"
        userSelect="none"
      >
        <Text
          as={motion.div}
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ type: "tween", duration: 0.16 }}
          fontSize="sm"
          fontWeight="600"
          letterSpacing=".04em"
          color="whiteAlpha.900"
          mb={2}
        >
          {greeting}
        </Text>

        <Text
          as={motion.div}
          key={time} // re-animates on change
          initial={{ opacity: 0.4, scale: 0.995 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ type: "tween", duration: 0.12 }}
          fontSize={["56px", "72px", "86px"]}
          lineHeight="0.95"
          fontWeight="800"
          color="white"
          letterSpacing="-0.02em"
        >
          {time}
        </Text>

        <Text
          as={motion.div}
          initial={{ opacity: 0, y: 4 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.04, type: "tween", duration: 0.16 }}
          fontSize="md"
          fontWeight="600"
          color="whiteAlpha.900"
          mt={2}
        >
          {weekday}
        </Text>

        <Text fontSize="sm" color="whiteAlpha.800">
          {date}
        </Text>

        <HStack spacing={2} mt={3} justify="center">
          <Badge
            variant="subtle"
            colorScheme="purple"
            rounded="full"
            px={3}
            py={1}
          >
            {tz.replace("_", " ")}
          </Badge>
          {/* add more chips if you want, e.g. week number */}
        </HStack>
      </Box>
    </>
  );
};

export default CenterClock;
